const routes = [
    {
      path: 'dashboard',
      name: 'Dashboard',
      icon: 'bx bxs-dashboard',
      layout: '/External',
      submenu: []
    },
    {
      path: 'raise-claim',
      name: 'Claim Management',
      icon: 'bx bx-list-ul',
      layout: '/External',
      submenu: []
    }
  ]
  export default routes;
  